import { toast } from "react-toastify";
import ErrorResponse from "./errorResponse";

export const toastApiError = (err) => {
  if (err.name === "AbortError" || err.name === "TimeoutError") {
    toast.error("Request timed out. Please try again.", { containerId: "warning" });
    return;
  }

  if (err instanceof ErrorResponse) {
    const status = err.response?.status;
    const message = err.errorMessage || "Something went wrong.";

    let extra = null;
    try {
      extra = err.finalErrorRes ? JSON.parse(err.finalErrorRes) : null;
    } catch (_) {}

    const displayMessage = extra?.userMessage || extra?.errorDescription || message;

    switch (status) {
      case 401:
        toast.error("Unauthorized. Please login again.", { containerId: "warning" });
        break;
      case 403:
        toast.error("You don't have permission.", { containerId: "warning" });
        break;
      case 404:
      case 405:
        toast.error("We're sorry, something went wrong", { containerId: "warning" });
        break;
      case 500:
        toast.error("Server error. Please try again later.", { containerId: "warning" });
        break;
      default:
        toast.error(displayMessage, { containerId: "warning" });
        break;
    }
    return;
  }

  toast.error("Network error. Please check your connection.", { containerId: "warning" });
};
